(() => {
  const products = [
    {
      title: 'Spicy Mala Shiitake Mushroom Sauce',
      image: 'https://cdn.shopify.com/s/files/1/0804/2994/0759/files/1_3e752298-a30c-4e62-b3cf-c4b657e4fb80.webp?v=1785396760'
    },
    {
      title: 'Five-Spice Inspired Shiitake Mushroom Sauce',
      image: 'https://cdn.shopify.com/s/files/1/0804/2994/0759/files/01.webp?v=1785397050'
    },
    {
      title: 'Black Truffle Sauce',
      image: 'https://cdn.shopify.com/s/files/1/0804/2994/0759/files/Black_truffle_sauce_premium_glass_jar_packaging.png?v=1785397504'
    },
    {
      title: 'Premium Porcini Mushroom Sauce',
      image: 'https://cdn.shopify.com/s/files/1/0804/2994/0759/files/Premium_porcini_mushroom_sauce.webp?v=1785397318'
    },
    {
      title: 'Matsutake Mushroom Sauce',
      image: 'https://cdn.shopify.com/s/files/1/0804/2994/0759/files/Matsutake_sauce.webp?v=1785397114'
    },
    {
      title: 'Wild Morel Mushroom Sauce',
      image: 'https://cdn.shopify.com/s/files/1/0804/2994/0759/files/Morel_sauce.png?v=1785397436'
    }
  ];

  function init() {
    const section = document.querySelector('.template-index .m-slideshow-section');
    if (!section || section.querySelector('.yf-product-thumb-nav')) return;

    const slideshow = section.querySelector('m-slideshow');
    const sliderContainer = slideshow && slideshow.querySelector('.swiper-container');
    if (!slideshow || !sliderContainer) return;

    const nav = document.createElement('div');
    nav.className = 'yf-product-thumb-nav';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Product slideshow navigation');

    const buttons = products.map((product, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'yf-product-thumb' + (index === 0 ? ' is-active' : '');
      button.dataset.slideIndex = String(index);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-label', product.title);
      button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');

      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'eager';
      image.decoding = 'async';
      button.appendChild(image);
      nav.appendChild(button);
      return button;
    });

    const actions = document.createElement('div');
    actions.className = 'yf-hero-actions';
    actions.setAttribute('aria-live', 'polite');

    sliderContainer.insertAdjacentElement('afterend', nav);
    nav.insertAdjacentElement('afterend', actions);

    function renderActions(swiper) {
      if (!swiper || !swiper.slides || !swiper.slides.length) return;
      const activeSlide = swiper.slides[swiper.activeIndex];
      const source = activeSlide && activeSlide.querySelector('.m-slide__button');
      actions.replaceChildren();
      if (source) actions.appendChild(source.cloneNode(true));
    }

    function setActive(index, swiper) {
      buttons.forEach((button, buttonIndex) => {
        const active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      const activeButton = buttons[index];
      if (activeButton && window.innerWidth < 768) {
        activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      renderActions(swiper);
    }

    function withSlider(callback, attempt = 0) {
      if (slideshow.slider && typeof slideshow.slider.slideToLoop === 'function') {
        callback(slideshow.slider);
      } else if (attempt < 50) {
        window.setTimeout(() => withSlider(callback, attempt + 1), 100);
      }
    }

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        withSlider((swiper) => {
          const realSlides = Array.from(swiper.slides || []).filter(
            (slide) => !slide.classList.contains('swiper-slide-duplicate')
          );
          if (index < realSlides.length) {
            swiper.slideToLoop(index);
            window.setTimeout(() => setActive(index, swiper), 40);
          }
        });
      });
    });

    withSlider((swiper) => {
      const sync = () => setActive(Number.isInteger(swiper.realIndex) ? swiper.realIndex : 0, swiper);
      swiper.on('slideChange', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
